import { Link } from 'react-router-dom';
import { companyInfo, navigation } from '../../data';
import { Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="inline-block group">
              <img 
                src="https://assets.auxodev.dk/assets/bbd899f1-874b-429b-b5f9-77a2b21d61ba/1bf8ce2d-291e-4ca8-b7a4-98511f9c0ee1.png" 
                alt="NR. GALTEN VOGNMANDSFORRETNING ApS" 
                className="h-12 w-auto object-contain brightness-0 invert transition-opacity duration-300 group-hover:opacity-80"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Professionel transport og distribution med fokus på troværdighed, struktur og mange års erfaring.
            </p>
            <div className="text-sm text-gray-400">
              <p>CVR: {companyInfo.cvr}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Hurtig navigation</h3>
            <ul className="space-y-4">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href} 
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Kontakt os</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-gray-400">
                <Phone className="w-5 h-5 text-blue-500 shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Mail className="w-5 h-5 text-blue-500 shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-white transition-colors text-sm">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-blue-500 shrink-0" />
                <span className="text-sm">
                  {companyInfo.address}
                </span>
              </li>
            </ul>
          </div>

          {/* Opening Hours or extra info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Område</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Vi opererer primært i Østjylland og omegn, men løser transportopgaver i hele Danmark efter aftale.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-xs">
            © {currentYear} {companyInfo.name}. Alle rettigheder forbeholdes.
          </p>
          <div className="flex space-x-6 text-xs text-gray-500">
            <Link to="/privatlivspolitik" className="hover:text-white transition-colors">Privatlivspolitik</Link>
            <Link to="/cookies" className="hover:text-white transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
